module.exports = __webpack_public_path__ + "img/dropdown_inactive.feb5a296.svg";